import React, { useState, useEffect, useContext } from "react";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import { borderRadius, display } from "@mui/system";
import FAQ from "../../elements/FAQ";
import { collection, query, where, getDocs } from "firebase/firestore"; // Import doc and getDoc
import { useFirestore } from "../../firebase/FirestoreContext";
import config from "../../config";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "../../elements/CopyToClipboard";
import FPButton from "../../elements/FPButton";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const Rewards = ({ isDevMode }) => {
  const db = useFirestore(); // Use the useFirestore hook

  const { user } = useContext(UserContext);
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  const [referralData, setReferralData] = useState(null);

  const navigate = useNavigate()

  useEffect(() => {
    const fetchReferralData = async () => {
      if (!db) {
        console.warn("Firestore not initialized yet.");
        return;
      }

      try {
        const referralCollectionRef = collection(db, `${collectionPath}Marketing/Referrals/DataBase`);
        const q = query(referralCollectionRef, where("name", "==", "referral_link"));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          // Assuming there's only one document with name "referral_link"
          const doc = querySnapshot.docs[0];
          setReferralData(doc.data());
          console.log("Document data:", doc.data());
        } else {
          console.log("No document with name 'referral_link' found!");
        }
      } catch (error) {
        console.error("Error fetching referral link:", error);
      }
    };

    fetchReferralData();
  }, [db, collectionPath]);

  const copyToClipboard = () => {
    if (!user) {
      return navigate("/signup")
    }
    if (navigator.clipboard && user && user.user_code) {
      navigator.clipboard
        .writeText(`Use my referral link to get $${referralData?.referralAmount} off your first order! https://getfullproof.com?ui=${user.user_code}`)
        .then(() => {
          alert("Referral link copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy referral code: ", err);
          alert("Failed to copy referral code to clipboard.");
        });
    } else {
      console.warn("Clipboard API not available or user code is missing.");
      alert("Unable to copy referral code to clipboard.");
    }
  };

  //const referralLink = `Hey! Join to Fullproof with my referral link and get $10! https://getfullproof.com?code=${user.user_code}`

  const shareReferalCode = (url) => {
    if (navigator.share) {
      navigator
        .share({
          title: "Fullproof Referral Code",
          text: `Use my referral link to get $${referralData?.referralAmount} off your first order! https://getfullproof.com?ui=${user.user_code}`,
          url: url,
        })
        .then(() => {
          console.log("Referral code shared successfully!");
        })
        .catch((error) => {
          console.error("Error sharing referral code: ", error);
        });
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  return (
    <>
      <Header search={false} />
      <div css={{ display: "flex", flexDirection: "column", maxWidth: "1140px", margin: "0 auto" }}>
        <div
          css={{
            padding: "15px",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            borderTop: "1px solid black",
            marginTop: 35,
            [mq[0]]: {
              paddingLeft: "0px",
            },
          }}
        >
          <div>
            <div css={{ ...styles.title }}>Earn Rewards</div>
            <div css={{ ...styles.image.container }}>
              <img src={"/images/reward.png"} alt="About Us" css={styles.image.image} />
            </div>
            <div css={{ height: 20 }} />
            {referralData ? (
              <div>
                <div css={{ ...styles.title }}>Get ${referralData?.refereeAmount} off when you refer someone</div>
                <p css={{ ...styles.content }}>Time to cash in on that popularity. Get the hookup for you and your friends.</p>
                <div css={{ height: 25 }} />
                <div
                  css={{
                    ...styles.content,
                    display: "flex",
                    flexDirection: "row",
                    fontSize: ".8rem",
                    [mq[0]]: {
                      fontSize: "1rem",
                    },
                  }}
                >
                  <div css={{ width: 40, display: "flex" }}>
                    <img src="/images/svg/Gift.svg" alt="Fullproof" css={{ width: 20, height: "auto" }} />
                  </div>
                  <div css={{ flex: 1 }}>
                    <b>You get ${referralData?.refereeAmount} off after their first order (refer as many times as you want)</b>
                    <br />
                    $25 minimum order • Valid for 90 days
                  </div>
                </div>
                <div css={{ height: 25 }} />
                <div
                  css={{
                    ...styles.content,
                    display: "flex",
                    flexDirection: "row",
                    fontSize: ".8rem",
                    [mq[0]]: {
                      fontSize: "1rem",
                    },
                  }}
                >
                  <div css={{ width: 40, display: "flex" }}>
                    <img src="/images/svg/user_gift.svg" alt="Fullproof" css={{ width: 30, height: "auto" }} />
                  </div>
                  <div css={{ flex: 1 }}>
                    <b>They get ${referralData?.referralAmount} off their first order</b>
                    <br />
                    $25 minimum order • Valid for 90 days
                  </div>
                </div>
                <div css={{ height: 25 }} />
                <CopyToClipboard
                  message={(!user || user.isAnonymous) ? "Sign up or sign in to get your referral code!" : "Click to copy referral link!"}
                  buttonText={(!user || user.isAnonymous) ? "Sign Up" : "COPY"}
                  preventCopyEvent={copyToClipboard}
                />
                {/* <div css={{ ...styles.copy.container }}>
                  <div css={{ ...styles.copy.text }}>{user ? user.user_code : "Sign up or sign in to get your referral code!"}</div>
                  <button
                    css={{ ...styles.copy.button }}
                    // copy to clipboard
                    onClick={copyToClipboard}
                  >
                    {user ? "COPY" : "Sign Up"}
                  </button>
                </div> */}
                {(user && !user.isAnonymous) &&
                  <div css={{ height: 35, display: "flex", justifyContent: "center", alignItems: "center" }} >
                    <FPButton
                      fontSize={"1.4rem"}
                      theme="dark"
                      background={"black"}
                      onClick={() => user?.user_code && shareReferalCode(`https://getfullproof.com/?ui=${user.user_code}`)}
                      width="20rem"
                    >
                      Share The Love
                    </FPButton>
                  </div>
                }
                {/* <div css={{ ...styles.button }} onClick={() => user?.user_code && shareReferalCode(`https://getfullproof.com/?ui=${user.user_code}`)}>
                  Share The Love
                </div> */}
              </div>
            ) : (
              <div css={{
                ...styles.content, textAlign: "center", fontSize: ".8rem", padding: "50px 0", [mq[0]]: {
                  fontSize: "1rem",
                },
              }}>
                <i>There is no active rewards available at the moment.</i>
              </div>
            )}
          </div>
        </div>
        <div css={{ height: 20 }} />
        <FAQ />
      </div>
      <Footer />
    </>
  );
};

const styles = {
  button: {
    backgroundColor: "black",
    color: "white",
    textAlign: "center",
    fontWeight: "600",
    padding: "10px 0",
    borderRadius: 50,
    [mq[0]]: {
      fontSize: "1.2rem",
      maxWidth: "340px",
      margin: "0 auto"
    },
  },
  copy: {
    container: {
      backgroundColor: "#F5F5F5",
      padding: "10px 15px",
      display: "flex",
      justifyContent: "center",
      overflow: "hidden",
      alignItems: "center",
      [mq[0]]: {
        marginTop: "25px",
        marginBottom: "25px",
      },
    },
    button: {
      backgroundColor: "white",
      padding: "8px 20px",
      borderRadius: 50,
      color: "black",
      fontWeight: "600",
      fontSize: ".8rem",
      border: "none",
      [mq[0]]: {
        fontSize: "1rem",
      },
    },
    text: {
      flex: 1,
      fontWeight: "600",
    },
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: 20,
    [mq[0]]: {
      fontSize: "2rem",
    },
  },
  content: {
    padding: "0px 0",
    fontWeight: "500",
    fontSize: ".9rem",
    [mq[0]]: {
      fontSize: "1.1rem",
    },
  },

  image: {
    container: {
      display: "flex",
      justifyContent: "center",
      borderRadius: 8,
      overflow: "hidden",
      alignItems: "center",
      maxWidth: "600px",
      margin: "0 auto",
    },
    image: {
      width: "100%",
      height: "auto",
    },
  },
};

export default Rewards;
